import React from "react";
import {useBooleanFeatureFlag} from "ub-feature-flagging-react";
import RemoteComponent from "shared/Utils/RemoteComponent";
import {CONTENT_RELEASE3_FLAG} from "shared/constants";
import {getenv} from "../../../../../util/getEnv";

const AsyncBlogTab = React.lazy(() => import(/* webpackChunkName: "BlogTab" */ "./BlogTab"));

const Blog = (props) => {
    const contentRelease3enabled = useBooleanFeatureFlag(CONTENT_RELEASE3_FLAG, false);
    const remoteScope = "blogRemoteEntry.js";
    const GATEWAY_URL = getenv("GATEWAY_URL");
    const API_URL = getenv("API_URL");
    const ASSETS_URL = getenv("ASSETS_URL");
    const CONTENT_FEDERATED_MODULES_APP_URL = getenv("CONTENT_FEDERATED_MODULES_APP_URL");

    return (
        <React.Fragment>
            {contentRelease3enabled ? (
                <RemoteComponent
                    url={`${CONTENT_FEDERATED_MODULES_APP_URL}/${remoteScope}`}
                    remoteScope="blog_page_federation"
                    remoteModule="./ProspectContent"
                    nestedProps={{
                        ...props,
                        env: {
                            API_URL,
                            GATEWAY_URL,
                            ASSETS_URL,
                        },
                    }}
                />
            ) : (
                <AsyncBlogTab {...props} />
            )}
        </React.Fragment>
    );
};

export default Blog;
